<template>
  <v-container fluid style="padding:0px 10px 5px 10px;width:100%;height:100%;">
    <v-layout column>
      <v-flex>
        <v-card>
          <v-card-title primary class="title" style="height:5%;width:100%;padding-top:5px;padding-bottom:5px;">Engine Types</v-card-title>
          <v-card-actions fill-height style="height:95%;width:100%;padding-top:0px;padding-bottom:10px;">
            <dx-data-grid
                class="grid"
                :data-source="engTypesGrid"
                :show-column-lines="true"
                :show-row-lines="true"
                :show-borders="true"
                :word-wrap-enabled="true"
                :row-alternation-enabled="false"
                :column-auto-width="true"
                @cellClick="gridClick"
                @cellPrepared="cellPrepared">
              <dx-column data-field="engType" caption="Engine Type"/>
              <dx-column data-field="controlSys" caption="Control System"/>
              <dx-column data-field="engCount" caption="Engine Counter"/>
              <dx-column data-field="shComp" caption="Shipping Companies"/>
            </dx-data-grid>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card>
          <Chart v-if="chartData['kpi']" v-bind:chartOptions="chartData['kpi']" v-bind:title="'Overall Engine KPI / Engine Type'" v-bind:active="active"/>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card>
          <Chart v-if="chartData['sfoc']" v-bind:chartOptions="chartData['sfoc']" v-bind:title="'SFOC / Engine Type​'" v-bind:active="active"/>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card>
          <v-card-title primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">Most Common Issues / Engine Type</v-card-title>
          <v-card-actions fill-height style="height:95%;width:100%;padding-top:0px;padding-bottom:10px;">
            <dx-data-grid class="grid"
                          :data-source="engIssuesGrid"
                          :show-column-lines="true"
                          :show-row-lines="true"
                          :show-borders="true"
                          :word-wrap-enabled="true"
                          :row-alternation-enabled="false"
                          :column-auto-width="true"
                          @cellClick="gridClick"
                          @cellPrepared="cellPrepared">
              <dx-column data-field="engType" caption="Engine Type"/>
              <dx-column data-field="issue1" caption="Issue 1"/>
              <dx-column data-field="issue2" caption="Issue 2"/>
              <dx-column data-field="issue3" caption="Issue 3"/>
            </dx-data-grid>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card>
          <Chart v-if="chartData['topIssues']" v-bind:chartOptions="chartData['topIssues']" v-bind:title="'Engine types with more issues'" v-bind:active="active"/>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card>
          <DropDownChart v-if="chartData['typeIssues']" v-bind:chartOptions="chartData['typeIssues']" v-bind:title="'Top Issues %'" v-bind:dropDownList="engineTypes" v-bind:active="active"/>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Chart from '../components/Chart'
import DropDownChart from '../components/DropDownChart'
import HorGauge from '../components/HorGauge'
import {DxDataGrid, DxColumn, DxPaging, DxScrolling} from 'devextreme-vue/data-grid';

export default {
  name: "EnginesOverview",
  components: {
    Chart,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxScrolling,
    HorGauge,
    DropDownChart
  },
  data() {
    return {
      chartData: {},
      fields: ['engType', 'controlSys', 'engCount', 'shComp'],
      engineTypes: [],
      engTypesGrid: [],
      engIssuesGrid: [],
      maxValues: {}
    }
  },
  props: {
    active: Boolean,
    engTypeData: Object
  },
  computed: {},
  created() {
  },
  mounted() {
    setTimeout(() => {
      this.setData();
    });
  },
  methods: {
    setMaxValues(dataField) {
      return Math.max(...this.engTypesGrid.map(function (item) {
        return item[dataField];
      }));
    },
    gridClick(e) {
      if ((e.column.dataField == "engType") && (e.rowType != "header")) {
        this.$router.push({path: `/engines/${e.value}`});
      }
    },
    cellPrepared(e) {
      if ((e.column.dataField == "engType") && (e.rowType != "header")) {
        e.cellElement.classList.add('clickable');
      }
    },
    setData() {
      this.engineTypes = Object.keys(this.engTypeData);

      this.engTypesGrid = [];
      for (let i = 0; i < this.engineTypes.length; i++) {
        this.engTypesGrid.push({
          'engType': this.engineTypes[i],
          'controlSys': this.engTypeData[this.engineTypes[i]].controlSystem,
          'engCount': this.engTypeData[this.engineTypes[i]].engineNo,
          'shComp': this.engTypeData[this.engineTypes[i]].companyNo
        });
      }

      this.maxValues['engCount'] = this.setMaxValues('engCount');
      this.maxValues['shComp'] = this.setMaxValues('shComp');

      this.engIssuesGrid = [];
      for (let i = 0; i < this.engineTypes.length; i++) {
        let obj = {
          'engType': this.engineTypes[i]
        };

        for (let j = 0; j < this.engTypeData[this.engineTypes[i]].common3faults.length; j++) {
          obj['issue' + (j + 1)] = this.engTypeData[this.engineTypes[i]].common3faults[j];
        }

        this.engIssuesGrid.push(obj);
      }

      this.$set(this.chartData, 'kpi', {
        chart: {
          height: 0,
          zoomType: 'xy'
        },
        legend: {
          enabled: false
        },
        xAxis: {
          categories: this.engineTypes,
          title:
              {
                text: 'Engine Type',
                align: 'high'
              },
          crosshair: true
        },
        yAxis: {
          title:
              {
                text: '[%]',
                align: 'high'
              }
        },
        exporting: {
          enabled: false
        },
        title: {
          text: undefined
        },
        series: [{
          type: 'column',
          animation: false,
          data: [],
          states: {
            hover: {
              enabled: false
            },
            normal: {
              animation: false
            },
            inactive: {
              opacity: 1
            }
          }
        }],
        tooltip: {
          formatter: function () {
            return 'Engine ' + this.x + ': ' + this.point.y.toFixed(1);
          }
        },
        credits: {enabled: false}
      });

      for (let i = 0; i < this.engineTypes.length; i++) {
        let kpi = this.engTypeData[this.engineTypes[i]].eng_KPI * 100,
            color = ((this.engTypeData[this.engineTypes[i]].eng_KPI_color == 0) ? 'rgb(60, 171, 48)' : ((this.engTypeData[this.engineTypes[i]].eng_KPI_color == 10) ? 'rgb(255, 184, 29)' : 'rgb(205, 57, 64)'));

        this.chartData['kpi'].series[0].data.push({
          y: ((kpi > 0) ? kpi : null),
          color: color
        });
      }

      this.$set(this.chartData, 'sfoc', {
        chart: {
          height: 0,
          zoomType: 'xy'
        },
        legend: {
          enabled: false
        },
        xAxis: {
          categories: this.engineTypes,
          title:
              {
                text: 'Engine Type',
                align: 'high'
              },
          crosshair: true
        },
        yAxis: {
          title:
              {
                text: '[g/kWh]',
                align: 'high'
              }
        },
        exporting: {
          enabled: false
        },
        title: {
          text: undefined
        },
        series: [{
          type: 'column',
          animation: false,
          data: [],
          states: {
            hover: {
              enabled: false
            },
            normal: {
              animation: false
            },
            inactive: {
              opacity: 1
            }
          }
        }],
        tooltip: {
          formatter: function () {
            return 'Engine ' + this.x + ': ' + this.point.y.toFixed(1);
          }
        },
        credits: {enabled: false}
      });

      for (let i = 0; i < this.engineTypes.length; i++) {
        let sfoc = this.engTypeData[this.engineTypes[i]].bsfc;

        this.chartData['sfoc'].series[0].data.push({
          y: ((sfoc != -1000) ? sfoc : null),
          color: 'rgb(144,170,218)'
        });
      }

      this.$set(this.chartData, 'topIssues', {
        chart: {
          height: 0,
        },
        exporting: {
          enabled: false
        },
        title: {
          text: undefined
        },
        plotOptions: {
          pie: {
            shadow: false,
            center: ['50%', '50%'],
            dataLabels: {
              enabled: false
            },
          }
        },
        series: [{
          type: 'pie',
          animation: false,
          data: [],
          size: '100%',
          innerSize: '70%',
          states: {
            hover: {
              enabled: false
            },
            normal: {
              animation: false
            },
            inactive: {
              opacity: 1
            }
          }
        }],
        tooltip: {
          formatter: function () {
            return this.point.name + ': ' + this.point.y.toFixed(1);
          }
        },
        credits: {enabled: false}
      });

      for (let i = 0; i < this.engineTypes.length; i++) {
        this.chartData['topIssues'].series[0].data.push({
          y: this.engTypeData[this.engineTypes[i]].faultNo,
          name: this.engineTypes[i]
        });
      }

      this.$set(this.chartData, 'typeIssues', {});

      for (let i = 0; i < this.engineTypes.length; i++) {
        this.$set(this.chartData.typeIssues, this.engineTypes[i], {
          chart: {
            height: 0,
          },
          exporting: {
            enabled: false
          },
          title: {
            text: undefined
          },
          plotOptions: {
            pie: {
              shadow: false,
              center: ['50%', '50%'],
              dataLabels: {
                enabled: false
              },
            }
          },
          series: [{
            name: this.engineTypes[i],
            type: 'pie',
            animation: false,
            data: [],
            size: '100%',
            innerSize: '70%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          }],
          tooltip: {
            formatter: function () {
              return this.point.name + ': ' + this.point.y.toFixed(1);
            }
          },
          credits: {enabled: false}
        });

        for (let j = 0; j < this.engTypeData[this.engineTypes[i]].topFaults.length; j++) {
          this.chartData.typeIssues[this.engineTypes[i]].series[0].data.push({
            y: Number(this.engTypeData[this.engineTypes[i]].topFaults[j].percentage),
            name: this.engTypeData[this.engineTypes[i]].topFaults[j].description
          });
        }
      }
    }
  },
  watch: {
    engTypeData: function () {
      setTimeout(() => {
        this.setData();
      });
    }
  }
}
</script>

<style>

.clickable {
  color: rgb(144, 170, 218);
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  text-align: left !important;
}

.clickable:hover {
  color: rgb(51, 82, 128);
}

.grid {
  font-size: 12px;
  font-family: 'Roboto', 'sans seriff';
  /*height:100% !important;*/
}

</style>
